import Vue from 'node_modules/vue'
import Router from 'node_modules/vue-router'
import Meta from 'node_modules/vue-meta'

import globals from '@/globals'

// Layouts
import Layout from '@/components/layout/Layout'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/monitoring/index.html/',
  mode: 'history',
  routes: [{
    path: '/',
    component: Layout,
    children: [{
      path: '',
      component: () => import('@/components/segment-roots/Monitoring')
    }, {
      path: 'customers',
      component: () => import('@/components/segment-roots/Customers')
    }, {
      path: 'aloha',
      component: () => import('@/components/segment-roots/Aloha')
    }, {
      path: 'users',
      component: () => import('@/components/segment-roots/Users')
    }, {
      path: 'notifications',
      component: () => import('@/components/segment-roots/Notifications')
    }, {
      path: 'statistics',
      component: () => import('@/components/segment-roots/Statistics')
    }, {
      path: 'sites',
      component: () => import('@/components/segment-roots/Sites')
    }, {
      path: 'devices',
      component: () => import('@/components/segment-roots/Devices')
    }]
  }]
})

router.afterEach(() => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading')

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
